import { http } from '@/core/helpers/axiosHelper';
import type { ApiResource } from '@future-harry/nxt-styles';
import type { MediaItem } from '@/modules/media-library/components/media-library.interface';
import { MEDIA_LIBRARY_ENDPOINTS } from './media-library.endpoints';

export async function fetchMediaLibrary(jobBoardId: number): Promise<MediaItem[]> {
   const response = await http.get<ApiResource<MediaItem[]>>(MEDIA_LIBRARY_ENDPOINTS.GET_ALL(jobBoardId));
   return response.data.data;
}

export async function uploadMediaItem(jobBoardId: number, file: File): Promise<MediaItem> {
   const formData = new FormData();
   formData.append('file', file);
   try {
      const response = await http.post<ApiResource<MediaItem>>(MEDIA_LIBRARY_ENDPOINTS.CREATE(jobBoardId), formData, {
         skipGlobalErrorHandling: true,
      } as any);

      return response.data.data;
   } catch (error) {
      throw error;
   }
}

export async function deleteMediaItem(jobBoardId: number, mediaId: number): Promise<void> {
   await http.delete(MEDIA_LIBRARY_ENDPOINTS.DELETE(jobBoardId, mediaId));
}

export async function updateMediaItem(jobBoardId: number, mediaId: number, changes: Partial<MediaItem>): Promise<MediaItem> {
   const response = await http.put<ApiResource<MediaItem>>(MEDIA_LIBRARY_ENDPOINTS.UPDATE(jobBoardId, mediaId), changes);
   return response.data.data;
}
